<template>
  <!-- Table Container Card -->
  <div style="height: inherit">
    <b-card id="page-referrals" no-body class="mb-0 p-2">
      <b-card-header class="pl-0 pr-0">
        <b-card-title
          ><h2>{{ $t(label("title")) }}</h2></b-card-title
        >

        <b-col v-if="canCreate" cols="12" md="8" class="d-none d-md-table">
          <b-col
            cols="12"
            class="d-flex align-items-between justify-content-end"
          >
            <b-button id="tooltip-create" variant="primary" @click="onCreate">
              <feather-icon icon="PlusIcon" class="mr-25" />
              <span class="text-nowrap">{{ $t(label("register")) }}</span>
            </b-button>
          </b-col>
        </b-col>

        <b-col
          v-if="canCreate"
          cols="12"
          sm="12"
          md="8"
          class="d-md-none d-flex justify-content-end align-items-center pt-2"
        >
          <b-button
            id="tooltip-create"
            variant="primary"
            @click="onCreate"
            class="btn-icon"
          >
            <feather-icon icon="PlusIcon" size="18" />
          </b-button>
        </b-col>

        <b-tooltip
          placement="top"
          target="tooltip-create"
          triggers="hover"
          @click="onInfo"
        >
          <strong>
            <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
            {{ $t("tutorial") }}
          </strong>
          <span> </span>
        </b-tooltip>
      </b-card-header>
      <Filterss
        :fields="fildsToFilters"
        :model="model"
        @filter-applied="applyFilters"
        @filter-reset="resetFilters"
      />

      <!-- Table for larger devices -->
      <b-table
        id="clients-table"
        responsive
        :head-variant="headVariant"
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :per-page="perPage"
        :busy="loading"
        :items="items"
        :fields="fields"
        class="d-none d-md-table shadow-sm !rounded"
      >
        <!-- A custom formatted header cell for field 'name' -->
        <template #head()="data">
          <span class="text-black">{{
            $t(labelHeader(data.label.toLowerCase()))
          }}</span>
        </template>

        <template #cell(guid)="data">
          <b-badge pill :variant="'light-success'" @click="info(data.value)">
            <feather-icon class="text-success" size="18" icon="KeyIcon" />
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <feather-icon
            v-if="canShow"
            class="text-success mr-25"
            size="18"
            icon="FileTextIcon"
            @click="onShow(data.item.idReferred)"
          />

          <feather-icon
            v-if="canEdit"
            class="text-primary mr-25"
            size="18"
            icon="EditIcon"
            @click="onEdit(data.item.idReferred)"
          />

          <feather-icon
            v-if="canDelete"
            class="text-danger"
            size="18"
            icon="Trash2Icon"
            @click="onDelete(data.item.idReferred)"
          />
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle ml-50"></b-spinner>
            <strong>{{ $t("loading") }}...</strong>
          </div>
        </template>
      </b-table>

      <!-- List for mobile devices -->
      <div id="list-container" class="d-block d-md-none mt-1 list-container">
        <b-list-group>
          <b-list-group-item
            v-for="item in items"
            :key="item.idReferred"
            class="flex-column align-items-start border border-primary rounded mb-1"
          >
            <div class="d-flex w-100 justify-content-between m-0 p-0">
              <p style="margin-bottom: 0 !important">
                <strong> {{ item.names }}</strong>
              </p>

              <b-dropdown
                variant="link"
                no-caret
                class="chart-dropdown"
                toggle-class="p-0"
                right
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="18"
                    class="text-body cursor-pointer"
                  />
                </template>
                <b-dropdown-item>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ $t("show") }}
                    <feather-icon
                      v-if="canShow"
                      class="text-success mr-25"
                      size="18"
                      icon="FileTextIcon"
                      @click="onShow(item.idReferred)"
                    />
                  </div>
                </b-dropdown-item>
                <b-dropdown-item>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ $t("edit") }}
                    <feather-icon
                      v-if="canEdit"
                      class="text-primary mr-25"
                      size="18"
                      icon="EditIcon"
                      @click="onEdit(item.idReferred)"
                    />
                  </div>
                </b-dropdown-item>
                <b-dropdown-item>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ $t("delete") }}
                    <feather-icon
                      v-if="canDelete"
                      class="text-danger"
                      size="18"
                      icon="Trash2Icon"
                      @click="onDelete(item.idReferred)"
                    />
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>

            {{ item.email != null ? item.email : "-" }}<br />
            {{ item.phoneNumber != null ? item.phoneNumber : "-" }} <br />
          </b-list-group-item>
          <b-list-group-item v-if="items.length == 0" class="text-center">
            {{ $t("notRegister") }}
          </b-list-group-item>
          <b-list-group-item v-if="loading">
            <b-spinner variant="success"></b-spinner>
          </b-list-group-item>
        </b-list-group>
      </div>
      <!-- pagination -->
      <div class="mx-2 d-none d-md-table">
        <b-row>
          <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="mb-2">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">{{
                $t("perPage")
              }}</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="w-50"
                @change="handlePerPageChange"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            sm="12"
            md="10"
            lg="10"
            xl="10"
            class="d-flex align-items-center justify-content-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
              @change="handlePageChange"
              first-number
              last-number
            >
              <template #prev-text>
                <feather-icon size="18" icon="ChevronLeftIcon" />
              </template>
              <template #next-text>
                <feather-icon size="18" icon="ChevronRightIcon" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BFormGroup,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";

import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import Filterss from "../components/filters/Filterss.vue";
import {
  allReferralsByCompany,
  deleteReferral,
} from "@/@core/api/request/referrals";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    vSelect,
    Filterss,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    model: "referrals",
    loading: false,
    totalRows: null,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    companyGuid: null,
    fields: [
      { label: "name", key: "names", sortable: true },
      { label: "email", key: "email", sortable: true },
      { label: "phone", key: "phoneNumber", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        type: "text",
        placeholder: "name",
        type: "search",
        visible: true,
      },
    ],
    appliedFilters: {},
    ppliedFilters: {},

    showOptions: false,
    name: null,
    filtersOn: false,
    hasNextPage: true,
  }),
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.hasNextPage = true;
      this.currentPage = 1;
      this.loadReferralsByCompany(guid);
    },
  },

  computed: {
    canCreate() {
      return canAccess("Referidos", "creation");
    },
    canShow() {
      return canAccess("Referidos", "reading");
    },
    canEdit() {
      return canAccess("Referidos", "edition");
    },
    canDelete() {
      return canAccess("Referidos", "elimination");
    },
  },

  created() {},

  async mounted() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadReferralsByCompany();

    document
      .getElementById("list-container")
      .addEventListener("scroll", this.handleScroll);
  },
  methods: {
    async handleScroll() {
      const container = document.getElementById("list-container");
      // console.log("fffffff",container.scrollTop + container.clientHeight,container.scrollHeight -1)
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadReferralsByCompanyInfinity();
      }
    },
    label(field) {
      return `pages.referrals.table.${field}`;
    },

    labelHeader(field) {
      return `pages.referrals.table.tableHeader.${field}`;
    },

    chargeParams() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);

      if (this.name != null && this.name != "")
        arrParams.push(`name,${this.name}`);
      arrParams.push(`active,${true}`);

      return getParams(arrParams);
    },

    chargeParamsWithFilters(name) {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);

      arrParams.push(`active,${true}`);

      arrParams.push(`name,${name}`);
      return getParams(arrParams);
    },
    loadReferralsByCompany() {
      console.log("Load data");
      // if (!this.hasNextPage) return;
      const param = this.chargeParams();
      this.loading = !this.loading;
      allReferralsByCompany(param)
        .then((resp) => {
          console.log("Data->", resp);
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    loadReferralsByCompanyInfinity() {
      if (!this.hasNextPage) return;
      const param = this.chargeParams();
      this.loading = !this.loading;
      allReferralsByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = [...this.items, ...data?.items];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    loadReferralsByCompanyWithFilters(name) {
      if (!this.hasNextPage) return;
      const param = this.chargeParamsWithFilters(name);
      this.loading = !this.loading;
      allReferralsByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
          if (resp.data == null) {
            this.alertToast(
              "danger",
              `Error`,
              `No se encontraron coincidencias`,
            );
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadReferralsByCompany();
    },

    handlePerPageChange() {
      // Reset currentPage to 1 when changing perPage
      this.currentPage = 1;
      this.loadReferralsByCompany();
    },
    onCreate() {
      this.$router.push({
        name: "referralCreate",
        params: {
          option: 1, // option 1 to create
        },
      });
    },
    onShow(idReferred) {
      this.$router.push({
        name: "referralEdit",
        params: {
          option: 2, // option 2 to show
          idReferred,
        },
      });
    },

    onEdit(idReferred) {
      this.$router.push({
        name: "referralEdit",
        params: {
          option: 3, // option 3 to edit
          idReferred,
        },
      });
    },

    onInfo() {},

    onDelete(idReferred) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteReferral(idReferred)
            .then((resp) => {
              console.log("Response->", resp);
              stopLoading();

              const status = _.get(resp, "status");
              if (status == 500) {
                this.message(
                  this.$t("Alert"),
                  this.$t("registerHasntDeleted"),
                  "error",
                );
                return;
              }
              this.message(
                this.$t("Deleted"),
                this.$t("beenDeleted"),
                "success",
              );
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", `Alerta codigo`, error.message);
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },

    applyFilters(filters) {
      this.appliedFilters = filters;
      this.name = filters.name;
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadReferralsByCompanyWithFilters(filters.name);
    },
    resetFilters() {
      this.appliedFilters = {};
      this.currentPage = 1;
      this.hasNextPage = true;
      this.name = null;
      this.loadReferralsByCompany();
    },
    message(title, text, icon) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        console.log("Alert result", result);
        if (result.isConfirmed) {
          this.loadReferralsByCompany();
        } else if (result.isDenied) {
          console.log("Denied!");
        }
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>

<style>
.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
</style>
